// extracted by mini-css-extract-plugin
export default {"container":"title_container__uogQ1","title":"title_title__KrurI","sub_title":"title_sub_title__9eyBd"};